import React from 'react';
import { CompactMoney } from '@websky/core/src/Money';
/**
 * В рамках задачи WEBSKY-6920, просили убрать иконку валюты и скоращение
 */
export const SearchFormDatepickerCompactMoney = props => {
    const amountRenderer = (amount, currency, limit) => Math.round(amount);
    return React.createElement(CompactMoney, Object.assign({}, props, { compactAmountRenderer: amountRenderer }));
};
